<template>
  <div class="">
    <!-- <p v-show="searching">getting lens details ..</p> -->
    <!-- <router-link :to="prevRoutePath">Previous Page</router-link> -->

    <v-container class="px-0 px-sm-4" v-if="lensData && lensData.name">
      <v-row justify="center">
        <v-col cols="12">
          <v-card
            :loading="searching"
            :class="{
              detailHeader: !isMobile && !isDiscontinued,
              discontinuedLensHeader: isDiscontinued,
            }"
            elevation="0"
            class="d-flex flex-column flex-sm-row flex-wrap pa-2 align-sm-center justify-center justify-sm-start"
          >
            <!-- min-height="115" -->
            <div class="imgDivSize my-1 mx-auto mx-sm-0">
              <product-image
                :fileString="lensData.image ? lensData.image : 'generic.svg'"
                type="scl"
                :maxHeight="95"
                :maxWidth="200"
                class=""
                :lazySrc="imageBase + 'generic.svg'"
              />
            </div>

            <div class="text-center">
              <div class="">
                <span class="text-h4">{{ lensData.name }}</span>
              </div>
              <span class="caption" v-if="lensData.genericName">
                (Private label {{ lensData.genericName }})
              </span>
              <span
                class="caption red--text"
                v-if="lensData.discontinued == '1'"
              >
                (discontinued lens)
              </span>
            </div>
            <div class="mx-auto mt-2">
              <company-popup :company="lensData.company" />
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" md="8">
          <v-card flat class="cardContent">
            <div class="cardTitle">Parameters</div>
            <soft-power-grid :powers="lensData.powers" class="mx-1" />
            <div
              class="caption d-flex flex-row flex-wrap px-2"
              v-if="lensData.bifocal == 1"
            >
              <v-spacer class="d-none d-sm-flex"></v-spacer>
              <div v-if="lensData.bifocal_type" class="mx-2">
                <b>Bifocal Type:</b> {{ lensData.bifocal_type }}
              </div>
              <div v-if="lensData.bifocal_center" class="mx-2">
                <b>Bifocal Center:</b> {{ lensData.bifocal_center }}
              </div>
            </div>
          </v-card>

          <v-card flat class="my-4 cardContent">
            <div
              class="cardTitle d-flex flex-row flex-wrap justify-space-between"
            >
              <div>Trial Lens Suggestions</div>

              <rx-parser
                dispatchToStore="setRx"
                triggerTitle="Refraction"
                buttonColor="#FFF"
                buttonStyle="border:1px solid #6d899d"
                @rxChange="rxObjects = $event"
                :disabled="!activeSubscription"
              ></rx-parser>
            </div>
            <v-card flat class="ma-2 whiteSection">
              <v-card-text class="darkerCardText">
                <div>
                  <trial-suggestions
                    v-if="rxObjects && activeSubscription"
                    :lensID="parseInt(lensData.tid)"
                    :rxs="rxObjects"
                    :includeSphereEquiv="parseInt(lensData.toric) != 1"
                  ></trial-suggestions>
                </div>
                <div v-if="!rxObjects || !activeSubscription">
                  Vertex (and transpose, if needed) your refraction and view
                  lens-specific trial lens suggestions.
                </div>
                <div v-if="!activeSubscription" class="">
                  This feature requires EyeDock Pro.
                </div>
              </v-card-text>
            </v-card>
            <div style="height: 0.5em" v-if="rxObjects"></div>
            <!-- <rx-summary-card-pair :showCrosses="false"> </rx-summary-card-pair> -->
          </v-card>

          <!-- <refraction-form
            :showCrosses="false"
            :showAddFields="lensData.bifocal == '1'"
          /> -->
          <v-card
            v-if="lensData.other_info != ''"
            flat
            class="my-4 cardContent"
          >
            <div class="cardTitle">More Info</div>
            <v-card flat class="ma-2 whiteSection">
              <v-card-text class="darkerCardText"
                ><div v-html="lensData.other_info"></div
              ></v-card-text>
            </v-card>
            <div style="height: 0.5em"></div>
          </v-card>

          <v-card flat class="my-4 cardContent" v-if="hasPrice">
            <div class="cardTitle">Prices</div>
            <v-card-text class="darkerCardText">
              <v-btn
                text
                small
                color="primary"
                @click="showAnnualPrices = !showAnnualPrices"
                >{{ showAnnualPrices ? "Hide" : "Show" }} Approximate Annual
                Prices
                <v-icon small color="primary"
                  >mdi-chevron-{{ showAnnualPrices ? "up" : "down" }}</v-icon
                >
              </v-btn>
              <div
                v-if="annualPrices && annualPrices.month && showAnnualPrices"
              >
                Approximate cost to patient: <sup>&dagger;</sup>
                <span v-for="(val, key) in annualPrices" :key="key">
                  <span class="mx-2"> ${{ val }}/{{ key }}</span>
                </span>
              </div>
              <online-price-summary
                v-if="scrapedPrices && activeSubscription"
                :scrapedPrices="scrapedPrices"
                class="mt-2"
              ></online-price-summary>
            </v-card-text>
          </v-card>
          <v-card
            flat
            class="my-4 cardContent"
            v-if="lensData.private_labels && lensData.private_labels.length"
          >
            <div
              class="cardTitle d-flex flex-row justify-space-between align-center"
            >
              <div>
                Private Label Variations ({{ lensData.private_labels.length }})
              </div>
              <v-btn icon @click="showYerPrivates = !showYerPrivates"
                ><v-icon
                  >mdi-chevron-{{ showYerPrivates ? "up" : "down" }}</v-icon
                ></v-btn
              >
            </div>
            <v-expand-transition>
              <v-card-text
                v-if="showYerPrivates"
                class="d-flex flex-column flex-sm-row flex-wrap align-start darkerCardText"
              >
                <div
                  v-for="plItem in lensData.private_labels"
                  :key="plItem.id"
                  class="my-1 my-sm-4 mr-4 d-flex flex-row flex-sm-column align-center"
                  :class="isMobile ? '' : 'privateLabelCard'"
                >
                  <div class="mr-2">
                    <v-img
                      :src="
                        imageBase +
                        (plItem.image ? plItem.image : 'generic.jpg')
                      "
                      :lazy-src="imageBase + 'generic.jpg'"
                      :height="isMobile ? 25 : 60"
                      :max-width="isMobile ? 30 : 150"
                      contain
                    ></v-img>
                  </div>
                  <div class="caption mt-2">{{ plItem.name }}</div>
                </div>
              </v-card-text>
            </v-expand-transition>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card flat class="cardContent">
            <div class="cardTitle">Attributes</div>

            <v-simple-table class="dataTable ma-2 whiteSection" dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Replacement</td>
                    <td class="caption align-center">
                      <img
                        :src="
                          '/images/icons/replace/replace_' +
                          lensData.replace_simple +
                          '_active.svg'
                        "
                        height="20"
                        width="20"
                        class="mr-3 float-left"
                      />
                      {{ lensData.replace_text | titleFilter }}
                    </td>
                  </tr>
                  <tr>
                    <td>Quantity</td>
                    <td>{{ lensData.qty | notSetQuestionMark }}</td>
                  </tr>
                  <tr v-show="lensData.wear != ''">
                    <td>Wear Type</td>
                    <td>{{ lensData.wear | titleFilter }}</td>
                  </tr>
                  <tr>
                    <td>Approved for Extended Wear</td>
                    <td><check-or-minus :val="lensData.ew" /></td>
                  </tr>
                  <tr>
                    <td>Polymer</td>
                    <td>
                      {{ lensData.polymer ? lensData.polymer.name : "" }}
                    </td>
                  </tr>
                  <tr>
                    <td>Water Content</td>
                    <td>
                      {{
                        lensData.polymer
                          ? parseInt(lensData.polymer.h2o) + "%"
                          : ""
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>dk</td>
                    <td>
                      {{ dk }} <span class="caption">{{ dkt }}</span>
                    </td>
                  </tr>

                  <tr>
                    <td>Center Thickness</td>
                    <td>{{ lensData.ct }}</td>
                  </tr>
                  <tr>
                    <td>Optic Zone</td>
                    <td>{{ lensData.oz | notSetQuestionMark }}</td>
                  </tr>
                  <tr>
                    <td>UV Protection</td>
                    <td><check-or-minus :val="lensData.uv" /></td>
                  </tr>
                  <tr>
                    <td>Visibility tint</td>
                    <td><check-or-minus :val="lensData.visitint" /></td>
                  </tr>
                  <tr v-if="lensData.markings && lensData.markings != ''">
                    <td>Lens Appearance</td>
                    <td>{{ lensData.markings }}</td>
                  </tr>

                  <tr>
                    <td>Approved as bandage lens</td>
                    <td><check-or-minus :val="lensData.bandage" /></td>
                  </tr>
                  <tr v-if="lensData.website">
                    <td colspan="2">
                      <a :href="lensData.website" target="_blank">
                        <v-icon color="primary" class="mr-2">mdi-web</v-icon>
                        Lens Website
                      </a>
                    </td>
                  </tr>
                  <tr v-if="lensData.fitting_guide">
                    <td colspan="2">
                      <a
                        :href="fitGuideBase + lensData.fitting_guide"
                        target="_blank"
                      >
                        <v-icon color="primary" class="mr-2"
                          >mdi-file-pdf-box</v-icon
                        >
                        Fitting Guide or Package Insert
                      </a>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div style="height: 0.5em"></div>
          </v-card>
          <v-card
            flat
            class="cardContent my-6"
            v-if="lensData.family && lensData.family.length"
          >
            <div class="cardTitle">In The Family..</div>
            <v-list dense nav>
              <v-list-item-group
                v-for="(famLens, i) in lensData.family"
                :key="'fam' + i"
              >
                <v-list-item
                  v-if="famLens.id != lensData.tid"
                  :to="'/cls/details/' + famLens.slug"
                >
                  <v-list-item-icon v-if="famLens.image">
                    <product-image
                      :fileString="
                        famLens.image ? famLens.image : 'generic.svg'
                      "
                      type="scl"
                      :maxHeight="30"
                      :maxWidth="50"
                      class=""
                      :lazySrc="imageBase + 'generic.svg'"
                    />
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{ famLens.name }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon
                    ><v-icon small class="mx-2"
                      >mdi-open-in-new</v-icon
                    ></v-list-item-icon
                  >
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="mediaImages && mediaImages.length">
        <v-col>
          <div class="overline">Related Media</div>
          <div class="caption">Click an image for full size</div>
          <!-- {{ mediaImages }} -->
          <dialog-lightbox
            :imagePath="mediaBase"
            :images="mediaImages"
            :iconHeight="350"
            :iconWidth="350"
            :canShowQuickCalcs="true"
          ></dialog-lightbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <soft-disclaimers class="mt-6"></soft-disclaimers>
        </v-col>
      </v-row>
    </v-container>
    <v-alert v-else-if="error" type="error" class="ma-8"
      >Lens not found</v-alert
    >

    <!-- {{ lensId }} -->
  </div>
</template>

<script>
// import Name from "../dir/file";
// import axios from "axios";
import ApiServices from "@/services/ApiServices";
import { mapState } from "vuex";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";
import FilterDictionary from "@/assets/js/cls/FilterDictionary";
import UserMixin from "@/assets/js/UserMixin";
import RxMethods from "@/assets/js/cls/RxMethods";
import ProductImage from "@/components/clStuff/ProductImage";
import CompanyPopup from "@/components/clStuff/CompanyPopup";
import SoftPowerGrid from "@/components/clStuff/SoftPowerGrid";
import CheckOrMinus from "@/components/universalStuff/CheckOrMinus";
import DialogLightbox from "@/components/universalStuff/DialogLightbox";

export default {
  name: "SoftDetails",
  components: {
    ProductImage,
    CompanyPopup,
    SoftPowerGrid,
    CheckOrMinus,
    RxParser: () => import("@/components/clStuff/RxParser"),
    TrialSuggestions: () => import("@/components/clStuff/TrialSuggestions"),
    OnlinePriceSummary: () => import("@/components/clStuff/OnlinePriceSummary"),
    SoftDisclaimers: () => import("@/components/clStuff/SoftDisclaimers"),
    DialogLightbox, //: () => import("@/components/universalStuff/DialogLightbox"),
  },
  mixins: [FiltersMixin, RxMethods, UserMixin],
  props: {},
  data: function () {
    return {
      showYerPrivates: false,
      filters: { ...FilterDictionary.filterDefaults },
      filterDefaults: { ...FilterDictionary.filterDefaults },
      lensId: null,
      lensName: "",
      searching: false,
      lensData: null,
      fav: false,
      error: null,
      rxObjects: null,
      privateId: null,
      showAnnualPrices: true,
      fitGuideBase: "https://www.eyedock.com/",
      imageBase: "https://www.eyedock.com/modules/Lenses/pnimages/lens_images/",
      mediaBase: "https://www.eyedock.com/lens_media/",

      // rxHash: null,
    };
  },
  title() {
    return `Lens Details ${this.nameOrId}`;
  },
  computed: {
    ...mapState(["loggedIn", "subscriber"]),
    companyInfo: function () {
      // todo - make the server side script return this info (as well as the polymer info)
      if (!this.lensData.comp_id) return {};
      let companyData =
        this.$store.getters.companiesById[this.lensData.comp_id];
      return companyData;
    },
    isDiscontinued: function () {
      return this.lensData && parseInt(this.lensData.discontinued) == 1;
    },
    dk: function () {
      let polyDk = this.lensData.polymer ? this.lensData.polymer.dk : 0;
      let lensDk = this.lensData.dk;
      let rtn = parseInt(polyDk);
      if (lensDk > 0) rtn = parseInt(lensDk);
      if (!rtn) rtn = "";
      return rtn;
    },
    dkt: function () {
      let dk = this.dk;
      let ct = this.lensData?.ct;
      if (!dk || !ct) return null;
      let dkt = dk > 0 && ct > 0 ? dk / ct / 10 : null;
      if (!dkt) return null;
      return ` (dk/t ${dkt.toFixed(1)})`;
    },

    nameOrId: function () {
      let name = "";
      if (this.lensData && this.lensData.name) {
        name = ` (${this.lensData.name})`;
      } else if (this.lensName != "") {
        name = ` (${this.lensName})`;
      } else if (this.lensId && this.lensId > 0) {
        name = ` (${this.lensId})`;
      }
      return name;
    },
    prevRoutePath: function () {
      return this.prevRoute ? this.prevRoute.path : "/cls";
    },
    isMobile: function () {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    annualPrices: function () {
      let rtn = {};
      // console.log("lookin' at prices");
      if (!this.lensData) return null;
      let ld = this.lensData;
      if (ld.annual_price && parseInt(ld.annual_price) > 0) {
        rtn.year = ld.annual_price;
        rtn.month = Math.floor(ld.annual_price / 12);
        rtn.day = (ld.annual_price / (12 * 30)).toFixed(2);
      } else rtn = null;
      return rtn;
    },
    scrapedPrices: function () {
      return this.lensData.prices && this.lensData.prices.length
        ? this.lensData.prices
        : null;
    },
    hasPrice: function () {
      let rtn = null;
      // console.log("hasPRice");
      if (this.annualPrices) rtn = true;
      // if (this.lensData.price && this.lensData.price != "") rtn = true;
      if (this.scrapedPrices) rtn = true;
      return rtn;
    },
    mediaImages: function () {
      if (!this.lensData?.media) return null;
      let rtn = [];
      this.lensData.media.forEach((row) => {
        if (row.media_type == "image") rtn.push(row.file);
      });
      return rtn;
    },
  },

  methods: {
    exitDetails() {
      this.$router.push(this.prevRoutePath);
    },

    updateHash: function () {
      // make a hash based on the Rxs (this will be used to make links to details pages that include the Rx )
      let hash = this.rxHashOU(this.rxObjects);
      this.updateHashWithParamString(hash);
    },

    getData() {
      this.searching = true;

      ApiServices.lensDetailsAPI(this.lensId, this.privateId)
        .then((response) => {
          this.searching = false;
          if (response.data.error) {
            this.error = response.data.error;
          } else {
            this.lensData = response.data;
          }
          //console.log("lensData", this.lensData);
          // todo - if lens not found initiate a deeper search?
        })
        .catch((e) => {
          // alert(e);
          this.error = "Error loading lens data";
          console.log(e);
        });
    },
  },

  filters: {
    // toBool: function(value) {
    //   let isTrue = value == "1" || value == 1 || value == "true";
    //   return isTrue ? "Yes" : "No";
    // },
    titleFilter: function (val) {
      if (val) val = val.charAt(0).toUpperCase() + val.slice(1);
      return val;
    },
    notSetQuestionMark: function (val) {
      return val && val != "" ? val : "?";
    },
  },
  watch: {
    rxObjects: {
      handler: "updateHash",
      deep: true,
    },
  },
  mounted() {
    // if (this.$route.params.id) {
    //   this.lensId = parseInt(this.$route.params.id);
    //   this.getData();
    // }

    let hashParts = this.hashParts();
    // console.log("hashParts", hashParts);
    if (hashParts) {
      if (hashParts.privateId) this.privateId = hashParts.privateId;
      let rxObjects = this.rxsFromHash(hashParts); // extract the rxs from the hash
      // console.log("rxs!: " + rxObjects);
      this.rxObjects = rxObjects;
    }
    if (this.$route.params.lensSlug) {
      // console.log("lensSlug: " + this.$route.params.lensSlug);
      this.lensId = this.$route.params.lensSlug;
      this.getData();
    } else {
      this.error = "No lens found";
    }
    this.setFiltersFromHash();
    if (localStorage.getItem("showAnnualPrices"))
      this.showAnnualPrices =
        localStorage.getItem("showAnnualPrices") == "true";
  },

  metaInfo() {
    return {
      title: "EyeDock/CLs | " + this.lensData?.name,
    };
  },
};
</script>

<style scoped>
.imgDivSize {
  width: 300px;
  height: 150;
}
.privateLabelCard {
  width: 200px;
}
.detailHeader {
  border: 1px solid #6e899d;
  min-height: 100px;
  background-image: linear-gradient(138deg, #f9feff 40%, #b9d5e9);
}
.discontinuedLensHeader {
  border: 1px solid #a08c8f;
  min-height: 100px;
  background-image: linear-gradient(138deg, #fff9fe 40%, #f9daf5);
}
.cardContent {
  border: 1px solid #c5c5c5;
  margin: 0 0px;
  /* box-shadow: 2px 3px 5px 1px #80808014 !important; */
}

.cardTitle {
  /* color: #4d4d4d; */
  background-color: #e8f2f9;
  border: 1px solid #a5c3d8;
  margin: -1px -1px;
  /* box-shadow: 0px 3px 5px 1px #80808014 !important; */
}

/* a {
  text-decoration: none;
} */
</style>
